import type { TacticAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { WarchestState } from "../types/game-state";

export interface TacticHandler {
  readonly validate: (
    state: WarchestState,
    action: TacticAction,
  ) => ValidationResult;
  readonly apply: (state: WarchestState, action: TacticAction) => WarchestState;
}

const registry = new Map<string, TacticHandler>();

export function registerTactic(tacticId: string, handler: TacticHandler): void {
  registry.set(tacticId, handler);
}

export function getTacticHandler(tacticId: string): TacticHandler | undefined {
  return registry.get(tacticId);
}

export function hasRegisteredTactic(tacticId: string): boolean {
  return registry.has(tacticId);
}
